<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>

              <div class="modal-header row" style="justify-content: flex-end;">
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
                <div class="col">
                  <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 class="title">Buat Policy</h2>
                <form>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="input-group">
                        
                        <template v-if="!form.customer_id">
                          <label class="label">Pilih Pelanggan<span style="color: red;">*</span></label>
                          <button class="btn btn-outline-primary mb-2" type="button" @click="selectCustomerModal = true" v-if="!selectCustomerModal">Tunjukkan Daftar Pelanggan</button>
                          <button class="btn btn-outline-primary mb-2" type="button" @click="selectCustomerModal = false" v-else>Sembunyikan Daftar Pelanggan</button>
                          <input v-if="selectCustomerModal" class="input--style-4" type="text"  v-model="table.filterCustomer.search" placeholder="Cari Pelanggan">
                        </template>
                        <template v-else>
                          <label class="label">Informasi Pelanggan<span style="color: red;">*</span></label>
                          <table class="table table-borderless">
                            <tbody>
                              <tr>
                                <td>Nama Pelanggan</td>
                                <td>{{customer.name}}</td>
                              </tr>
                              <tr>
                                <td>KTP</td>
                                <td>{{customer.ktp}}</td>
                              </tr>
                              <tr>
                                <td>No. Telefon</td>
                                <td>{{customer.phone_number}}</td>
                              </tr>
                              <tr>
                                <td colspan="2"><button type="button" class="btn btn-outline-danger w-30" @click="resetCustomer">Ganti Pelanggan</button></td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                        
                        
                      </div>
                      <vue-universal-table
                          api_url="/api/v1/masterData/customer"
                          :filter="table.filterCustomer"
                          v-if="selectCustomerModal && !form.customer_id"
                          :limit_per_page="5"
                          :fields="table.fields"
                          :disable_limit_per_page="true"
                          :buttons="table.buttons"
                          @onPilih="selectCustomer"
                          :update="table.update"
                        />
                    </div>
                    
                  </div>

                  <div class="row row-space" v-if="form.customer_id">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="input-group">
                        
                        <template v-if="!form.car_id">
                          <label class="label">Pilih Mobil Pelanggan<span style="color: red;">*</span></label>
                          <button class="btn btn-outline-primary mb-2" type="button" @click="selectCustomerCarModal = true" v-if="!selectCustomerCarModal">Tunjukkan Daftar Mobil</button>
                          <button class="btn btn-outline-primary mb-2" type="button" @click="selectCustomerCarModal = false" v-else>Sembunyikan Daftar Mobil</button>
                          <input v-if="selectCustomerCarModal" class="input--style-4" type="text"  v-model="table.filterCar.search" placeholder="Cari Pelanggan">
                        </template>
                        <template v-else>
                          <label class="label">Informasi Mobil<span style="color: red;">*</span></label>
                          <table class="table table-borderless">
                            <tbody>
                              <tr>
                                <td>No. Rangka Mobil</td>
                                <td>{{car.chassis_number}}</td>
                              </tr>
                              <tr>
                                <td>Merk dan Tipe Mobil</td>
                                <td>{{car.car_name}}</td>
                              </tr>
                              <tr>
                                <td>Tahun</td>
                                <td>{{car.year}}</td>
                              </tr>
                              <tr>
                                <td colspan="2"><button type="button" class="btn btn-outline-danger w-30" @click="resetCar">Ganti Mobil</button></td>
                              </tr>
                            </tbody>
                          </table>
                        </template>
                        
                        
                      </div>
                      <vue-universal-table
                          api_url="/api/v1/masterData/customer_car"
                          :filter="table.filterCar"
                          v-if="selectCustomerCarModal && !form.car_id"
                          :limit_per_page="5"
                          :fields="table.fieldsCar"
                          :disable_limit_per_page="true"
                          :buttons="table.buttons"
                          @onPilih="selectCar"
                          :update="table.updateCar"
                        />
                    </div>
                    
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="input-group">
                        <label class="label">Nomor Polis<span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="policy_number"  v-model="form.policy_number" placeholder="Ketik Nomor Polis Asuransi">
                        
                      </div>
                    </div>
                    
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Nama <span style="color: red;">*</span></label>
                        <input class="input--style-4" type="text" name="policy_name" v-model="form.insured_name" placeholder="Ketik Nama">
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                      <div class="input-group">
                        <label class="label">Tanggal Kadaluarsa<span style="color: red;">*</span></label>
                        <DatePicker input-class="input--style-4" class="w-100" type="text" name="policy_expiry" v-model="form.policy_expiry" placeholder="Pilih Tanggal Kadaluarsa Polis"/>
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-12">
                      <div class="input-group">
                        <label class="label">Third Party Liability</label>
                        <input class="input--style-4" type="text" name="policy_tpl" v-model="form.tpl" placeholder="Isi Jumlah TPL">
                        <span>(Jika tidak ada Mohon di isi 0)</span>
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="input-group">
                        <label class="label">Perusahaan Asuransi<span style="color: red;">*</span></label>
                        <multi-select
                          class="mt-1"
                          :options="insuranceCompanies.map(type => type.id)"
                          :custom-label="opt => insuranceCompanies.find(x => x.id == opt).company_name"
                          placeholder=""
                          v-model="form.insurance_company"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="input-group">
                        <label class="label">Tipe Asuransi<span style="color: red;">*</span></label>
                        <multi-select
                          class="mt-1"
                          :options="options.insuranceType.map(type => type.id)"
                          :custom-label="opt => options.insuranceType.find(x => x.id == opt).name"

                          placeholder=""
                          v-model="form.policy_type"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row row-space">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <div class="input-group">
                        <label class="label">Unggah Dokumen Polis<span style="color: red;">*</span></label>
                        <input type="file"  class="input--style-4" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" @change="validateSize"/>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col mt-5" style="text-align: center">
                      <button type="button" class="btn btn-outline-danger" style="font-size:140%" @click="$emit('closeModal')">Kembali</button>
                      <button type="button" class="btn btn-primary ml-5" style="font-size:150%" @click="submitForm()">Tambah</button>
                    </div>
                  </div>
                </form>
              </div>
          </div>
        </div>
      </div>
      <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
    </div>
  </div>

 
</transition>
</template>

<script>
  import debounce from 'debounce'
  import MultiSelect from 'vue-multiselect';
  import DatePicker from 'vuejs-datepicker';
  import FormData from 'form-data'

  export default {
    data () {
      return{
        customer: null,
        
		car: null,
		file : null,
        form : {
          policy_type : '',
          policy_expiry : '',
          insured_name : '',
          policy_number : '',
          insurance_company : '',
          customer_id : null,
          car_id : null,
          car_color_id: null,
          tpl : 0,
		  year: null,
		  document : null
        },
        dragging : false,
        table : {
          filterCustomer: {
            search : ''
          },
          filterCar : {
            search : '',
            customer_id : ''
          },
          buttons: [
            {
              title : 'Pilih',
            }
          ],
          fields: [
            {
              title : 'No. KTP',
              variable : 'ktp'
            },
            {
              title : 'Name',
              variable : 'name'
            },
            {
              title: 'Phone Number',
              variable: 'phone_number'
            }
          ],
          fieldsCar: [
            {
              title : 'No. Rangka',
              variable : 'chassis_number'
            },
            {
              title : 'Tipe Mobil',
              variable: 'car_name'
            },
            {
              title : 'Tahun',
              variable: 'year'
            }
          ],
          updateCar: 0,
          update: 0
        },
        options : this.$store.getters.getFilterOptions,
        selectCustomerModal : false,
        selectCustomerCarModal: false
      }
    },
    props : ['insuranceCompanies'],
    components : {
      MultiSelect,
      DatePicker
    },
    mounted () {
    },
    watch : {
      'table.filterCustomer.search' : debounce(function (e) {
        console.log("b")
        this.table.update++;
      }, 500),
      'table.filterCar.search' : debounce(function (e) {
        console.log("b")
        this.tableCar.update++;
      }, 500)
    },
    methods : {
      validateForm(){
        var valid = true;
        var error = [];

        if(this.form.policy_number == '' || this.form.policy_number == null){//Policy Number [Required]
          valid = false;
          error.push('Nomor Polis wajib diisi!');
        }

        if(this.form.insured_name == '' || this.form.insured_name == null){//Name [Required]
          valid = false;
          error.push('Nama wajib diisi!');
        }

        if(this.form.policy_expiry == '' || this.form.policy_expiry == null){//Name [Required]
          valid = false;
          error.push('Tanggal Kadaluarsa Polis wajib diisi!');
        }

        if(this.form.policy_type == '' || this.form.policy_type == null){//Name [Required]
          valid = false;
          error.push('Tipe Asuransi wajib diisi!');
        }

        if(this.form.customer_id == '' || this.form.customer_id == null){//Name [Required]
          valid = false;
          error.push('Pelanggan wajib dipilih!');
        }

        if(this.form.car_id == '' || this.form.car_id == null){//Name [Required]
          valid = false;
          error.push('Mobil wajib dipilih!');
        }

        if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        else return valid;
      },
		async submitForm(){
			let vm = this;
			if(vm.validateForm()){
				let formData = new FormData()

        formData.append('file', this.file[0])
    

				this.$http.post('/api/v1/insurance/upload', formData, {headers : {"Content-Type":'multipart/form-data'}})
				.then((resp) => {
					this.form.document = resp.data.data.filename
          this.form.tpl = this.form.tpl ? parseFloat(this.form.tpl) : 0
					this.$http.put(`/api/v1/masterData/customer_car/${this.car.chassis_number}`, this.form)
					.then((resp)=>{
						// alert(`Partshop ${vm.form.name} has been created`);
						this.$store.dispatch('triggerAlert', [true, [`Polis Nomor ${vm.form.policy_number} telah berhasil dibuat`]]);
						this.$emit('updateTable');
						this.$emit('closeModal');
					})
					.catch((err)=>{
						console.log(err);
						this.$store.dispatch('triggerAlert', [false, (String(err).split("Error:"))[1].split("; ")]);
					})
				})
				.catch((err) =>{
					console.log(err)
					this.$store.dispatch('triggerAlert', [false, (String(err).split("Error:"))[1].split("; ")]);
				})
				
			}
		},
		validateSize : function(data){
			var file = data.target.files;

			if(file.length > 1) {
				this.$store.dispatch('triggerAlert' , [false , "Maksimum Dokumen Di Unggah : 1 Dokumen"])
				return false;
			}

			var size  = file.size / 1024 / 1024;

			if(size > 20)
			{
				this.$store.dispatch('triggerAlert' , [false ,"Maksimum Size Dokumen 10 MB"])
				return false;
			}

			this.fileError = "";
			this.file = file
			return true;
		},
      selectCustomer (obj) {
        obj = JSON.parse(obj)
        this.customer = obj;
        this.form.customer_id = obj.id
        this.table.filterCar.customer_id = obj.id
      },
      selectCar (obj) {
        obj= JSON.parse(obj)
        this.car = obj;
        this.form.car_id = obj.car_id
        this.form.car_color_id = obj.car_color_id
        this.form.year = obj.year

      },
      resetCustomer () {
        this.customer = null
        this.form.customer_id = null
        this.table.filterCar.customer_id = null
      },
      resetCar () {
        this.car = null;
        this.form.car_id = null
        this.form.car_color_id = null
      }
    }
  }
</script>

<style>

/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
